module.exports = __webpack_public_path__ + "img/8f2.e7a5cb7b.jpg";